// /client/src/main.ts

import * as THREE from 'three'
import mainScene from './mainScene.js'
import inputManager from './inputManager.js'

const MIN_SUPPORTED_WIDTH = 1128
let appStarted = false

function showSmallScreenWarning(minWidth: number, onContinue: () => void) {
  const canvas = document.getElementById('app') as HTMLCanvasElement | null
  if (canvas) {
    canvas.style.display = 'none'
  }

  const warning = document.createElement('div')
  warning.id = 'screen-size-warning'
  warning.innerHTML = `
    <div style="max-width: 640px; width: 100%; padding: 28px 24px; border-radius: 16px; background: rgba(29, 29, 39, 0.96); border: 1px solid #3a3a4a; color: #f3f0ff; font-family: 'Overpass', sans-serif; text-align: center; box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);">
      <h1 style="margin: 0 0 12px 0; font-size: 1.45rem;">Screen width is below recommended size</h1>
      <p style="margin: 0; font-size: 1rem; line-height: 1.45;">
        This app is designed for at least <strong>${minWidth}px</strong> width.
        You can continue anyway, but the interface may be hard to use on smaller screens.
      </p>
      <p style="margin: 12px 0 0 0; font-size: 0.95rem; line-height: 1.45; color: #d7cef7;">
        Mobile input is currently limited and may not work reliably yet. We are actively working on improvements.
      </p>
      <button id="warning-continue" style="margin-top: 16px; padding: 10px 22px; border: 1px solid #c1b8ff; border-radius: 10px; background: #b384ff; color: #12121a; font-family: 'Overpass', sans-serif; font-size: 0.95rem; font-weight: 700; cursor: pointer;">
        OK, continue
      </button>
    </div>
  `

  warning.style.position = 'fixed'
  warning.style.inset = '0'
  warning.style.zIndex = '99999'
  warning.style.display = 'flex'
  warning.style.alignItems = 'center'
  warning.style.justifyContent = 'center'
  warning.style.padding = '16px'
  warning.style.background = 'radial-gradient(circle at 20% 20%, #2f2f45 0%, #13131d 65%)'

  const continueButton = warning.querySelector('#warning-continue') as HTMLButtonElement | null
  continueButton?.addEventListener('click', () => {
    warning.remove()
    if (canvas) {
      canvas.style.display = 'block'
    }
    onContinue()
  })

  document.body.appendChild(warning)
}

function startApplication() {
  if (appStarted) {
    return
  }
  appStarted = true

  const canvas = document.getElementById('app') as HTMLCanvasElement | null
  if (!canvas) {
    return
  }
  canvas.style.display = 'block'

  let width = window.innerWidth
  let height = window.innerHeight

  const renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
      alpha: true,
      preserveDrawingBuffer: true,
      powerPreference: 'high-performance'
  })

  renderer.setSize(width, height)
  renderer.setClearColor(0x1B1B25)

  // Pass the renderer into the scene's constructor
  const scene = new mainScene(renderer)
  //scene.initialize()

  const inputManagerInstance = inputManager.getInstance(scene, renderer)
  inputManagerInstance.init()

  function updateWindowSize()
  {
    width = window.innerWidth
    height = window.innerHeight
    renderer.setSize(width, height)
  }

  function tick() {
    inputManagerInstance.update()
    updateWindowSize()
    scene.mainCamera.updateAspect(width/height)
    scene.mainCamera.update(0)
    renderer.render(scene, scene.mainCamera.getCamera())

    requestAnimationFrame(tick)
  }
  tick()
}

if (window.innerWidth < MIN_SUPPORTED_WIDTH) {
  showSmallScreenWarning(MIN_SUPPORTED_WIDTH, startApplication)
} else {
  startApplication()
}